import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import {LorenAuthenticationService} from '../../services/loren-authentication-service/loren-authentication.service';
import {LorenPrivilegeEntityType} from '../../../features/loren-roles/interfaces/loren-role.interface';

@Directive({
    selector: '[lorenShowForPrivileges]',
    standalone: false
})
export class LorenShowForPrivilegeDirective implements OnInit {
    private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
    private authenticationService = inject(LorenAuthenticationService);
    private viewContainer = inject(ViewContainerRef);


    requiredPrivileges: string[] = [];

    @Input() set lorenShowForPrivileges(privileges: LorenPrivilegeEntityType[]) {
        this.requiredPrivileges = privileges;
    }

    ngOnInit() {
        if (!this.requiredPrivileges || this.requiredPrivileges.length === 0) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            return;
        }

        const privileges = this.authenticationService.getPrivileges();
        // if user has one of required roles
        if (privileges?.some(x => this.requiredPrivileges.includes(x))) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
